<template>
  <div>
    <b-row>
      <b-col cols="12">
        <b-card>
          <b-row>
            <b-col cols="6">
              <b-form-group>
                <label for="name">Role Name</label>
                <input
                  type="text"
                  class="form-control"
                  placeholder="Enter Role Name"
                  v-model="name"
                  @keyup.enter="doFilter"
                />
              </b-form-group>
            </b-col>
            <b-col cols="6">
              <b-form-group>
                <label for="name">Status</label>
                <select v-model="status" class="form-control">
                  <option value="">--PLEASE SELECT--</option>
                  <option value="1">Active</option>
                  <option value="0">Inactive</option>
                </select>
              </b-form-group>
            </b-col>
          </b-row>
         
            <div slot="footer" class="search-panel-btn">
              <b-button
                type="submit"
                size="sm"
                variant="primary"
                class="search-btn"
                @click="doFilter"
                ><i class="cui-magnifying-glass icons"></i> Search</b-button
              >
              <b-button
                type="reset"
                size="sm"
                variant="danger"
                @click="resetFilter"
                ><i class="cui-ban icons"></i> Reset</b-button
              >
            </div> 
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  data() {
    return {
      name: "",
      status:""
    };
  },
  methods: {
    doFilter() {
      let filters = {
        name: this.name,
        status: this.status
      };
      this.$events.fire("filter-set", filters);
    },
    resetFilter() {
      this.name = "";
      this.status = "";
      this.$events.fire("filter-reset");
    }
  }
};
</script>

<style scoped>
.search-panel-btn {
  float: right;
}

.search-btn {
  margin-right: 5px;
}
</style>
